import { render, staticRenderFns } from "./f2g-noteForm.vue?vue&type=template&id=314f6759&scoped=true"
import script from "./f2g-noteForm.vue?vue&type=script&lang=js"
export * from "./f2g-noteForm.vue?vue&type=script&lang=js"
import style0 from "./f2g-noteForm.vue?vue&type=style&index=0&id=314f6759&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314f6759",
  null
  
)

export default component.exports